import { render, staticRenderFns } from "./RegistrationsFilter.vue?vue&type=template&id=2bd621ce"
import script from "./RegistrationsFilter.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationsFilter.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports